import Alpine from 'alpinejs'
import Glide from '@glidejs/glide'

Alpine.plugin(Alpine => {
    Alpine.magic('glide', (el) => {
        return (config) => {
            config = Object.assign({
                type: 'carousel',
                perView: 1,
                focusAt: 'center',
            }, config)

            const glide = el.__glide = new Glide(el, config)
            glide.mount()

            return {
                next() {
                    glide.go('>')
                },
                prev() {
                    glide.go('<')
                },
                instance() {
                    return el.__glide
                }
            }
        }
    })
})

window.Alpine = Alpine
Alpine.start();

$(function () {
    if (document.querySelector('[data-carousel]')) {
        const glide = new Glide('[data-carousel]', {
            type: 'carousel',
            perView: 1,
            focusAt: 'center'
        });
    
        glide.mount();
    }

    const closeMobileNav = () => {
        $('#mobile-nav').animate({
            right: '-75%',
        }, '200ms', () => {
            $('#mobile-nav').addClass('hidden')
        })

        $('#mobile-nav-overlay').fadeOut()
        $('html').css('overflow-y', '')
    }

    const openMobileNav = () => {
        $('#mobile-nav').removeClass('hidden')
        $('#mobile-nav').animate({
            right: '0px',
        }, '200ms')
        $('#mobile-nav-overlay').fadeIn()
        $('html').css('overflow-y', 'hidden')
    }

    $('#mobile-nav-trigger').on('click', function () {
        openMobileNav()
    });

    $('#mobile-nav-overlay').on('click', function () {
        closeMobileNav()
    });

    $('#close-mobile-nav').on('click', function () {
        closeMobileNav()
    });

    $('[data-accordion]').each(function () {
        const $this = $(this)

        $this.data({
            active: false
        })

        const $toggle = $this.find('[data-toggle]')
        const $indicator = $this.find('[data-toggle-indicator]')
        const $content = $this.find('[data-content]')

        $toggle.click(function () {
            if (! $this.data('active')) {
                $this.data('active', true)
            } else {
                $this.data('active', false)
            }

            $indicator.toggleClass('rotate-180')
            $content.slideToggle()
        });
    })
})